export const CHART_DATA = [
  { name: 'Added contact', value: 400 },
  { name: 'Deleted contact', value: 300 },
  { name: 'Unsaved contact', value: 300 },
];


export const RECENT_ADDED_CONTACT_COLUMNS = [
  {
    name: "Name",
    selector: (row: any) => row.name,
    sortable: true,
  },
  {
    name: "Email",
    selector: (row: any) => row.email,
    sortable: true,
  },
  {
    name: "Phone",
    selector: (row: any) => row.phone,
    sortable: true,
  },
  {
    name: "Date Created",
    selector: (row: any) => row.date_created,
    sortable: true,
  },
];

export const RECENT_ADDED_CONTACT_DATA = [
  {
    id: 1,
    name: "Beetlejuice",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 2,
    name: "Ghostbusters",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 3,
    name: "Beetlejuice",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 4,
    name: "Ghostbusters",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 5,
    name: "Beetlejuice",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 6,
    name: "Ghostbusters",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 7,
    name: "Beetlejuice",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  {
    id: 8,
    name: "Ghostbusters",
    email: "justme@mail.com",
    phone: "7867522720",
    date_created: "03/23/23",
  },
  
];
